module.exports = __webpack_public_path__ + "static/media/IconApps.f55f52d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/IconApps.svg
// module id = 315
// module chunks = 0